module.exports = __webpack_public_path__ + "static/media/nav-trackers.835f1292.svg";